module.exports = __webpack_public_path__ + "img/diana.d99846db.png";